import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Store from '../redux/store';
import { WebsocketClient } from '../websocket/module';
import { MessengerModule } from "../messenger/module";
import io from 'socket.io-client';
import { SendOrderRequestEventObject, CreateOrderRequestSuccessedEventObject } from '../websocket/type';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { createHashHistory } from 'history';
import i18n from '../i18n';
import { getWebsocketUrl } from '../tools/utils';
import { getCacheField } from '../tools/get-cache-field';

let time: NodeJS.Timeout;

class FoodTip extends React.Component<Props, State>{
    public messengerModule: MessengerModule;
    constructor(props: Props) {
        super(props);
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
        this.state = {
            // 审核提示显隐
            tipDisplayMode: 'NORMAL',
            // 倒计时
            second: getCacheField('resendOrderSecond')
        } as State;
    }
    // *********************
    // 生命周期
    // *********************
    componentDidMount() {
        // $ 判断订单推送请求 有其他人发起，禁用重新发送按钮
        WebsocketClient.addListener('RESEND_ORDER_REQUEST', this.resendOrderRequest)
        WebsocketClient.addListener('CREATE_ORDER_REQUEST_SUCCESSED', (data: CreateOrderRequestSuccessedEventObject) => {
            clearInterval(time)
        })
        // 开启倒计时
        this.changeSecond()

        // 2.5秒后自动折叠
        setTimeout(() => {
            this.setState({
                tipDisplayMode: 'SMALL'
            })
        }, 2500)
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (nextProps.approvalStatus !== this.props.approvalStatus) {
            // 审核通过自动关闭审核提示框
            if (nextProps.approvalStatus === 'APPROVED') {
                setTimeout(this.closeTip, 2000)
            }
        }
    }

    componentWillUnmount() {
        // clearInterval(time)
        WebsocketClient.removeListener('RESEND_ORDER_REQUEST', this.resendOrderRequest)

    }
    public resendOrderRequest = (data: SendOrderRequestEventObject) => {
        this.messengerModule.say({
            message: `${i18n.t('menu_page_text_reset_send_success')}`,
            level: "Success",
        });
        // 开启倒计时
        this.reChangeSecond()
    }
    // 关闭审核提示
    closeTip = () => {
        const { approvalStatus } = this.props;
        this.setState({
            tipDisplayMode: approvalStatus === 'REVIEW' ? 'SMALL' : 'NO',
        })
        if (approvalStatus === 'APPROVED') {
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'approvalStatus',
                value: 'NO'
            })
        }
    }

    // 重新发送
    resendOrder = async () => {
        let tableId = getCacheField('tableId');
        let tableName = getCacheField('tableName');
        let selectMenu = getCacheField('orderTab.menuList');
        let orderCode = getCacheField('orderTab.orderCode');
        if (selectMenu && tableId) {
            // 发送创建订单的请求
            this.createOrderRequest(tableId, tableName, selectMenu, orderCode);
            // 开启倒计时
            this.reChangeSecond()
        } else if (tableId === undefined) {
            this.messengerModule.say({
                message: `${i18n.t('menu_page_text_table_invalid')}`,
                level: "Warning",
            });
            createHashHistory().push({ pathname: '/' });
        } else {
            this.messengerModule.say({
                message: `${i18n.t('menu_page_text_table_invalid')}`,
                level: "Warning",
            });
            createHashHistory().push({ pathname: '/Home' });
        }
    }

    // 开启倒计时
    changeSecond = () => {
        if (time) {
            clearInterval(time)
        }
        time = setInterval(() => {
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'resendOrderSecond',
                value: Store.getState().resendOrderSecond - 1
            })
            if (Store.getState().resendOrderSecond < 0) {
                clearInterval(time)
            }
        }, 1000)
    }

    // 重新倒计时
    reChangeSecond = () => {
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'resendOrderSecond',
            value: 60
        })
        this.changeSecond()
    }

    /**
    * 发送创建订单的请求
    * @param tableId 桌台id
    * @param  select_menu 选择的菜品
    */
    createOrderRequest(tableId: number, tableName: string, select_menu: { main_group_id: number; main_group_name: string }, orderCode = '') {
        // $ 向服务端发送订单审核请求
        let { orderTab } = Store.getState();
        // const strArr = (Store.getState().serverUrl).split(':')
        // const serverUrl = strArr[1].split('//')
        // const msgSocket = io(`ws://${serverUrl[1]}:3002`);
        const msgSocket = io(`ws://${getWebsocketUrl()}`);
        const sendOrderRequest = {
            type: 'QOP_CREATE_ORDER_REQUEST',
            tableId: tableId.toString(),
            table_name: tableName,
            menu: select_menu,
            adultNum: orderTab.normalNum,
            childNum: orderTab.childNum,
            otherNum: orderTab.otherNum,
            customer: orderTab.customer,
            orderCode
        }
        console.log(sendOrderRequest, '向服务端发送订单审核请求');
        // 发送到 '呼叫服务'
        msgSocket.emit('CALL_SERVICE', sendOrderRequest);
        // $ 向其他人发起创建订单请求，直接跳转到菜单页
        WebsocketClient.emitOrderClients({
            event: 'RESEND_ORDER_REQUEST',
            customer: orderTab.customer,
            selectMenu: select_menu,
        })
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'orderRequestMsg',
            value: sendOrderRequest
        })
    }


    render() {
        const { approvalStatus, resendOrderSecond } = this.props;
        const { tipDisplayMode } = this.state;

        return (
            <div
                className={tipDisplayMode === 'NO' ? 'hideTip' : ''}
            >
                <div className={tipDisplayMode === 'NORMAL' ? 'tip borderRadius' : 'tip'}>
                    {approvalStatus === 'REVIEW' ?
                        //   审核中
                        <div className={tipDisplayMode === 'NORMAL' ? 'tipContent tipBig' : 'tipContent tipSmall'}>
                            <div className={tipDisplayMode === 'NORMAL' ? 'normal' : 'hide'}>
                                <div className="tipTop">
                                    <div className="textLeft">
                                        <p>{i18n.t('menu_page_text_under_review')}……</p>
                                        <p>{i18n.t('menu_page_text_locked_state')}</p>
                                    </div>
                                    <IconButton onClick={this.closeTip}>
                                        <CloseIcon></CloseIcon>
                                    </IconButton>
                                </div>
                                <div className="tipBottom">
                                    <Button
                                        color="secondary"
                                        variant="contained"
                                        onClick={this.resendOrder}
                                        disabled={resendOrderSecond > 0}>
                                        {i18n.t('menu_page_text_reset_send')} {resendOrderSecond > 0 && `${resendOrderSecond}s`}
                                    </Button>
                                </div>
                            </div>

                            <div
                                className={tipDisplayMode === 'NORMAL' ? 'hide' : 'small'}
                                onClick={() => { this.setState({ tipDisplayMode: 'NORMAL' }) }}>
                                <p>
                                    {i18n.t('menu_page_text_under_review')}……
                                </p>
                                <div>
                                    <Button
                                        size="small"
                                        color="secondary"
                                        variant="contained"
                                        onClick={this.resendOrder}
                                        disabled={resendOrderSecond > 0}>
                                        {i18n.t('menu_page_text_reset_send')} {resendOrderSecond > 0 && `${resendOrderSecond}s`}
                                    </Button>
                                </div>
                            </div>
                        </div>
                        :
                        // 审核通过
                        <div>
                            <div className="tipContent">
                                <div>
                                    <p>{i18n.t('menu_page_text_approved')}</p>
                                    <p>{i18n.t('menu_page_text_order_unlocked')}</p>
                                </div>
                                <IconButton onClick={this.closeTip}>
                                    <CloseIcon></CloseIcon>
                                </IconButton>
                            </div>

                        </div>
                    }
                </div>

            </div>
        )
    }
}

export default withSnackbar(FoodTip)

type Props = {
    // 审核状态
    approvalStatus: 'REVIEW' | 'APPROVED' | 'NO' | 'REJECTED'
    // 倒计时
    resendOrderSecond: number
} & WithSnackbarProps
type State = {
    // 审核提示显隐
    tipDisplayMode: 'NO' | 'NORMAL' | 'SMALL',

}
